jQuery(document).ready(function($) { 
	/******************************/
	/*********** WOW EFFEC SCROLL PAGE **********/
		/******************************/


  /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE // NEW VERSION *************/
  /******************************************/

  var popup_already_display = sessionStorage.getItem('popState');
 // popup_already_display = 'test';

  if(popup_already_display != 'shown'){
    
    if ( $( ".lightbox_popup_event--link" ).length ) {
      $('.lightbox_popup_event--link').featherlight({
        otherClose : 'span.icon-close',
        loading: 'Chargement...', 
        afterOpen: function(event){
           sessionStorage.setItem('popState','shown');
           // console.log(this.lightbox); // this contains all related elements
            $('.featherlight-content').addClass('featherlight_special_event');
          }
        
      }).click();
    }
  }



  /******************************************/
    /********** LIGHTBOX VIDEO HOME PAGE // OLD VERSION *************/
  /******************************************/

  var popup_already_display_video = sessionStorage.getItem('popStateVideo');
 // popup_already_display = 'test';

	if (($( "#video_showreel" ).length && popup_already_display_video != 'shown') || ( $("#video_showreel" ).length && $('body').hasClass('home')  )) {
 	videojs.options.flash.swf = "video-js.swf";
    $('document').ready(function(){
      $.magnificPopup.open({
        type:'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        items: {
        	src: '#video_showreel' 
    	},
        callbacks: {
        open: function() {
           videojs('showreel_lightbox').play();
           sessionStorage.setItem('popStateVideo','shown');
        },
        close: function() {
          videojs('showreel_lightbox').pause();
        }
        // e.t.c.
      }

      });
      // $('.open-popup-link').on('click',function(){
      //   videojs('showreel_lightbox').play();
      // });
    });
  }


	//  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
  // WOW EFFECT //


		/******************************/
	/*********** ANIMATION ALL PAGE **********/
		/******************************/

	
	

  	var BgIntroPage =  $('#h0');
	TweenLite.fromTo(BgIntroPage, 0.5, {css:{opacity:0,scale:0.5}}, {css:{scale:1, y:0, opacity:1},delay:0});

	var Footer =  $('#colophon');
	TweenLite.fromTo(Footer, 0.5, {css:{opacity:0,y:100}}, {css:{y:0, opacity:1},delay:0.4});

	var Masthead =  $('#masthead, #menu-toggle');
	TweenLite.fromTo(Masthead, 0.5, {css:{opacity:0,y:-200}}, {css:{y:0, opacity:1},delay:0.4});
	

	var IntroPage =  $('.TxtCarreIntroPage');
	var introPageBack = $('.TxtCarreIntroPage .back');
	var introPageFront = $('.TxtCarreIntroPage .front');
	TweenLite.fromTo(IntroPage, 0.5, {css:{scale:0.5, y:-200, opacity:0}}, {css:{scale:1, y:0, opacity:1}, onComplete:afterThisAnim});
	function afterThisAnim(){
		$('.TxtCarreIntroPage').addClass('active_Intro');
	}
	// TweenLite.to(introPageBack, 1, {  css:{rotationY:0,,delay:0.5ease:Linear.easeNone});
	// TweenLite.to(introPageFront, 1, { css:{rotationY:180}, delay:1,ease:Linear.easeNone});


		/******************************/
	/*********** GESTION HOME PAGE **********/
		/******************************/

		$WidthWindow = $(window).width();

		/*********** SCROLL SMOOTH **********/
		  $('.next-btn-js').on('click', function(){
	        $('.specialotherbg').each(function() {
	            var pos = $(this).offset().top;   
	            if($WidthWindow < 769) pos = pos - 75;
	            if ($(window).scrollTop() < pos - 100) {
	                $('html, body').animate({
	                    scrollTop: pos
	                }, 500);
	                return false;
	            }
	        });

	         return false;

	    });



		if ( $( "body.home" ).length ) {

		$(window).scroll(function(){
		   // Get container scroll position
		   var fromTop = $(this).scrollTop();
		   
		   if ($("#ToContactForm").offset().top < fromTop + 100){

		       $("body").addClass('ToForm');

		   }else{
		   	 $("body").removeClass('ToForm');
		   }
		          
		});

	}
	



		/*********** SCROLL SMOOTH **********/
	    var menuItems = $('.ToBottom-btn-page');
	    var offsetTop;
		menuItems.click(function(e){
		  var href = $(this).attr("href"),
		      offsetTop = href === "#" ? 0 : $(href).offset().top-0;
		
			      	 $('html, body').stop().animate({ 
				      scrollTop: offsetTop
				  }, 500);
		   
			  e.preventDefault();
		});



/*********** HOME PAGE SCROLLMAGIC  **********/

if ( $( "#CarreIntro" ).length ) {


	var controller = new ScrollMagic.Controller(); // init controller
	
	/*********** SCENE 1 // FLIP CONTAINER **********/

// build scene
	var scene = new ScrollMagic.Scene({
			triggerElement: "#trigger1"
		})
	.setClassToggle(".IntroCube", "hover") // add class toggle
	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "flip carre"}) // add indicators (requires plugin)
	.addTo(controller);


	/*********** SCENE 2 // APPARITION TXT 1 **********/

	// build scene
	var scene2 = new ScrollMagic.Scene({
				triggerElement: "#trigger2"
		})
	//.setClassToggle(".flip-container", "sombre") // add class toggle
	.setClassToggle("#CarreIntro", "AppearTxt1")

	
	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "devient sombre"}) // add indicators (requires plugin)
	.addTo(controller);



	/*********** SCENE 3 // APPARITION TXT 2 **********/

	// build scene
	var scene3 = new ScrollMagic.Scene({
				triggerElement: "#trigger3"
		})
	//.setClassToggle(".flip-container", "sombre") // add class toggle
	.setClassToggle(".TxtCarreIntro--zonetextA", "hover") // add class toggle


	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "devient text"}) // add indicators (requires plugin)
	.addTo(controller);



	var scene4 = new ScrollMagic.Scene({
				triggerElement: "#trigger4"
	})
	//.setClassToggle(".flip-container", "sombre") // add class toggle
	.setClassToggle("#CarreIntro", "DeleteZoneA") // add class toggle


	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "devient text"}) // add indicators (requires plugin)
	.addTo(controller);


	var scene5 = new ScrollMagic.Scene({
				triggerElement: "#trigger5"
	})
	//.setClassToggle(".flip-container", "sombre") // add class toggle
	.setClassToggle(".TxtCarreIntro--zonetextB", "hover") // add class toggle


	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "devient text"}) // add indicators (requires plugin)
	.addTo(controller);

	var scene6 = new ScrollMagic.Scene({
				triggerElement: "#trigger6"
	})
	//.setClassToggle(".flip-container", "sombre") // add class toggle
	.setClassToggle("#CarreIntro", "FormAppear") // add class toggle


	//.setTween(".CarreIntro-Item", 0.5, {backgroundColor: "green", scale: 2.5}) // trigger a TweenMax.to tween
	//.addIndicators({name: "devient text"}) // add indicators (requires plugin)
	.addTo(controller);

	 ///////
	///   ///
		 

	$('.GalleryTop').slick({
        //setting-name: setting-value
        dots: false,
        infinite:true,
        arrows:false,
        draggable:false,
        autoplay: true,
  		autoplaySpeed: 3500,
  		pauseOnHover:false,
  		speed:1400,
  		fade: true,
      });


	var GalleryTop =  $('.GalleryTop');
	TweenLite.fromTo(GalleryTop, 0.5, {css:{opacity:0,scale:0.5}}, {css:{scale:1, y:0, opacity:1},delay:0});



}

var h_fin_section1 = $('.GalleryTop').height();
h_fin_section1 = parseInt(h_fin_section1 - h_fin_section1/3);

$( window ).scroll(function() {

	if ( $( "#CarreIntro" ).length ) {

		var IntroPagehome =  $('#CarreIntro');

		var y=$(window).scrollTop();
		if(y > h_fin_section1){
			
			if(IntroPagehome.css('opacity') != 1){
				TweenLite.to(IntroPagehome, 0.5, {css:{scale:1, y:0, opacity:1}});
			}
			
		}else{
			TweenLite.to(IntroPagehome, 0.5, {css:{opacity:0, scale:0, y:-100}});
		}


	}

});






		/******************************/
	/*********** OUVERTURE / FERMETURE MENU **********/
		/******************************/

	$FACTEUR_ANIM_MENU = 0.5;
	var btn_ouverture_menu = $("#menu-toggle");
	var block_to_anim = $("#block_to_anim");

	var $transition_menu_start = false;
	$( "#menu-toggle" ).hover(
	  function() {
	  	if(!$transition_menu_start)
	  	{ //$("body").addClass( "transition_menu_start" );
	 //   console.log('HOVER HERE');
	    TweenLite.to('.CacheMenu-part--part1', 0.3, {width:'115px',ease:Power3.easeOut});
	 }
	  }, function() {
	   // $("body").removeClass("transition_menu_start" );
	    if(!$transition_menu_start){ TweenLite.to('.CacheMenu-part--part1', 0.3, {width:'0px',ease:Back.easeIn}); }
	    
	  }
	);	


	

	$('.home .BtnContact').click(function() {
		btn_ouverture_menu.trigger( "click" );
	});

			$(btn_ouverture_menu).click(function() {

		   		 $transition_menu_start = true;
				// ON REFERME LE MENU
				if($(this).hasClass('toggled')){
					// on est en mobile, il faut refermer le menu //
					btn_ouverture_menu.removeClass('toggled');
					$("body").removeClass('to_menu_open');

				      TweenLite.to('.CacheMenu-part--part2', 0.2, {x:'0%', y:0, z:0,onComplete:function(){
				            $(".CacheMenu-part--bg").css( "width", '0px'); 
				      }});
				      TweenLite.to('.CacheMenu-part--part2', 0.2, {width:'0px', delay:0.3});
				      TweenLite.to('.CacheMenu-part--part1', 0.2, {x:'0%',y:0,z:0,delay:0.2});
				       //
				      TweenLite.to('.CacheMenu-part--part1', 0.2, {width:'0px',delay:0.3,onComplete:function(){
		        		 $transition_menu_start = false;
		      }});

				}else{

				  // LES TRANSITIONS D'APPARITION ICI //
			      TweenLite.to('.CacheMenu-part--part1', 0.4*$FACTEUR_ANIM_MENU, {width:'100%'}); // 0 
			      TweenLite.to('.CacheMenu-part--part1', 0.4*$FACTEUR_ANIM_MENU, {x:'-110%', y:0, z:0, delay:0.4*$FACTEUR_ANIM_MENU});
			      TweenLite.to('.CacheMenu-part--part2', 0.4*$FACTEUR_ANIM_MENU, {right:0, width:'100%',delay:0.1*$FACTEUR_ANIM_MENU,onComplete:function(){
		         		$(".CacheMenu-part--bg").css( "width", '100%'); 
		         		$("body").removeClass('to_menu_open'); // apparition menu //
		        		 block_to_anim.addClass('to_visible'); // menu visible
		      }});

		      TweenLite.to('.CacheMenu-part--part2', 0.4*$FACTEUR_ANIM_MENU, {x:'-110%', y:0, z:0, delay:0.6*$FACTEUR_ANIM_MENU});
		      btn_ouverture_menu.addClass('toggled');

				}
			 	
			 	return false;
			}); // fin click sur btn_ouverture_menu




			///// //// / // //// / ////
	/// 
	///		/// //// ///// // /// /// /


	/* See related post at
		https://codepen.io/Javarome/post/full-page-sliding
	*/
	// function ScrollHandler(pageId) { 
	//   var page = $('#' + pageId);
	//   var pageStart = page.offset().top;
	//   var pageJump = false;

	//   function scrollToPage() {
	//     pageJump = true;
	//       $('html, body').animate({ 
	//       scrollTop: pageStart 
	//     }, {
	//       duration: 700,
	//       complete: function() {
	//       	setTimeout(function() {
	// 		  pageJump = false;
	// 		  console.log('LALLALALA');
	// 		}, 1500);

	//        // pageJump = false;
	//       }
	//     });  
	//   }
	//   window.addEventListener('wheel', function(event) {
	//    var viewStart = $(window).scrollTop();
	//    if (!pageJump) { 
	//       var pageHeight = page.height();
	//       var pageStopPortion = pageHeight / 2;
	//       var viewHeight = $(window).height();

	//       var viewEnd = viewStart + viewHeight;
	//       var pageStartPart = viewEnd - pageStart;
	//       var pageEndPart = (pageStart + pageHeight) - viewStart;
	      
	//       var canJumpDown = pageStartPart >= 0; 
	//       var stopJumpDown = pageStartPart > pageStopPortion; 
	      
	//       var canJumpUp = pageEndPart >= 0; 
	//       var stopJumpUp = pageEndPart > pageStopPortion; 

	//       var scrollingForward = event.deltaY > 0;
	//       if (  ( scrollingForward && canJumpDown && !stopJumpDown) 
	//          || (!scrollingForward && canJumpUp   && !stopJumpUp)) {
	//         event.preventDefault();
	//         scrollToPage();
	//       } 
	//    } else {
	//      event.preventDefault();
	//    }    
	//   });
	// }
	// new ScrollHandler('h0'); 
	// new ScrollHandler('h1');
	// new ScrollHandler('h2');
	// new ScrollHandler('h3');
	// new ScrollHandler('h4');
	// new ScrollHandler('h5');
	// new ScrollHandler('h6');

			

}); // fin ready menu